"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'blogs/v3/blog-posts';
var CONTENT_GROUP_URI = 'blog-settings/v1/blogs';
var SLUG_URI = 'content/api/v4/contents/slug-for-title';
var COMPOSITION_FETCH_TIMEOUT = 15000;

var getReadURI = function getReadURI(id) {
  return BASE_URI + "/" + id + "/buffer";
};

var getWriteURI = function getWriteURI(id) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var uri = BASE_URI + "/" + id;

  if (buffer) {
    uri += '/buffer';
  }

  return uri;
};

var applyDefaultOptions = function applyDefaultOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.assign({
    safeMode: true
  }, options);
};

var PostManager = /*#__PURE__*/function () {
  function PostManager() {
    (0, _classCallCheck2.default)(this, PostManager);
  }

  (0, _createClass2.default)(PostManager, [{
    key: "createPost",
    value: function createPost(data) {
      return _apiClient.default.post(BASE_URI, {
        data: data
      });
    }
  }, {
    key: "fetch",
    value: function fetch(id) {
      var url = getReadURI(id);
      return _apiClient.default.get(url, {
        timeout: COMPOSITION_FETCH_TIMEOUT
      });
    }
  }, {
    key: "fetchContentGroups",
    value: function fetchContentGroups() {
      var query = {
        limit: 300,
        property: ['name', 'id', 'urlBase']
      };
      return _apiClient.default.get(CONTENT_GROUP_URI, {
        query: query
      }).then(function (resp) {
        return resp.objects;
      });
    }
  }, {
    key: "savePost",
    value: function savePost(data) {
      var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var options = applyDefaultOptions({
        data: data,
        query: query
      });
      return _apiClient.default.put(getWriteURI(data.get('id'), buffer), options);
    }
  }, {
    key: "fetchSlugForTitle",
    value: function fetchSlugForTitle(query) {
      return _apiClient.default.get(SLUG_URI, {
        query: query
      });
    }
  }]);
  return PostManager;
}();

exports.default = PostManager;
module.exports = exports.default;